import { InputFormProps } from "./interface/formInterface";
import FormCheckInput from "./form_check";
import { useEffect } from "react";
import FormDate from "./form_date_time";
import AdminAPI from "../../api/admin";
import ButtonStyle from "../style/button.component";

const RecommendedForm = (props: InputFormProps) => {
  const { value, label, width, setValue } = props;
  const { value1, value2, value3, setValue1, setValue2, setValue3, value4 } =
    value;

  const update = async () => {
    if (value1 && value2 && value3) {
      const data = {
        pubId: value4,
        startDate: value2,
        endDate: value3,
      };
      try {
        await AdminAPI.updateRecommendedPubData(data);
        alert("수정되었습니다. ");
      } catch (e) {}
    }
  };

  return (
    <div
      style={{
        width: width,
        marginTop: "10px",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: "15px",
      }}
    >
      <div
        style={{
          width: "25%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <FormCheckInput
          value={value1}
          setValue={setValue1}
          width="100%"
          label="추천 홀덤펍"
        />
      </div>
      {value1 && (
        <div
          style={{
            width: "70%",
            display: "flex",
            gap: "20px",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <FormDate
              value={value2}
              label={"시작일"}
              setValue={setValue2}
              width={"100%"}
            ></FormDate>
            <FormDate
              value={value3}
              label={"종료일"}
              setValue={setValue3}
              width={"100%"}
            ></FormDate>
          </div>
          <div
            style={{
              width: "33%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <ButtonStyle
              width="70px"
              height="40px"
              border="none"
              backgroundColor="#1976D2"
              borderRadius="50px"
              color="white"
              onClick={update}
            >
              수정하기
            </ButtonStyle>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecommendedForm;
